module.exports = __webpack_public_path__ + "img/wiping-swipe-for-floors-purple.06944dfb.svg";